import router from '../router'
import store from '../store'

const errorHandler = err => {
  if (!err) return
  if (err.status === 401) {
    let path = window.location.hash
    let pathEncoded = encodeURIComponent(process.env.SERVICE_URL + '/' + path.split('?xsrfToken=')[0])
    pathEncoded = pathEncoded.replace(/%23/g, '%2523')
    localStorage.clear()
    window.location.href = process.env.PORTAL_URL_BASE + pathEncoded
  } else if (err.status === 404) {
    err.responseJSON && err.responseJSON.traceId && store.dispatch('setTraceId', err.responseJSON.traceId)
    router.push('/error-404')
  } else if (err.status === 500) {
    err.responseJSON && err.responseJSON.traceId && store.dispatch('setTraceId', err.responseJSON.traceId)
    router.push('/error-500')
  } else if (err.status === 503) {
    err.responseJSON && err.responseJSON.traceId && store.dispatch('setTraceId', err.responseJSON.traceId)
    router.push('/error-503')
  } else {
    err.responseJSON && err.responseJSON.traceId && store.dispatch('setTraceId', err.responseJSON.traceId)
    router.push('/generic-error')
  }
}

const defs = [
  {
    cmd: 'getAdverseMediaAlerts',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/organization/v1/{orgId}/dashboard/adverseMediaAlerts',
    type: 'GET'
  },
  {
    cmd: 'getComplianceAlerts',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/organization/v1/{orgId}/dashboard/complianceAlerts',
    type: 'GET'
  },
  {
    cmd: 'getCreditRisk',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/organization/v1/{orgId}/dashboard/creditRisk',
    type: 'GET'
  },
  {
    cmd: 'getGeographicDistribution',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/organization/v1/{orgId}/dashboard/geographicDistribution',
    type: 'GET'
  },
  {
    cmd: 'getIndustryClassifications',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/organization/v1/{orgId}/dashboard/industryClassifications',
    type: 'GET'
  },
  {
    cmd: 'getMasterCompanies',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/organization/v1/{orgId}/masterList?page={page}&pageSize={pageSize}&name={companyName}&match={matchType}',
    type: 'GET'
  },
  {
    cmd: 'getMonitoredCompanies',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/organization/v1/{orgId}/monitoredList?page={page}&pageSize={pageSize}&name={companyName}',
    type: 'GET'
  },
  {
    cmd: 'getMyCompanyDetails',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/user/v1/{cuid}/myCompanyDetails',
    type: 'GET'
  },
  {
    cmd: 'getRevenueDistribution',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/organization/v1/{orgId}/dashboard/revenueDistribution',
    type: 'GET'
  },
  {
    cmd: 'getSubscriptionDetails',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/subscription/v1/organization/{orgId}/subscriptionStatus',
    type: 'GET'
  },
  {
    cmd: 'getCompanyDetails',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/company/v1/companyDetails',
    type: 'POST'
  },
  {
    cmd: 'disableChecklist',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/user/v1/{cuid}/disableChecklist',
    type: 'POST'
  },
  {
    cmd: 'downloadMasterList',
    cmdType: 'secured',
    // accepts: 'application/json',
    contentType: 'text/csv',
    call: '/p/apiProxy/organization/v1/{orgId}/downloadMasterList',
    type: 'GET'
  },
  {
    cmd: 'downloadMonitoredList',
    cmdType: 'secured',
    // accepts: 'application/json',
    contentType: 'text/csv',
    call: '/p/apiProxy/organization/v1/{orgId}/downloadMonitoredList',
    type: 'GET'
  },
  {
    cmd: 'companyMonitorStart',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/company/v1/monitor/start',
    type: 'POST'
  },
  {
    cmd: 'companyMonitorStop',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/company/v1/monitor/stop',
    type: 'POST'
  },
  {
    cmd: 'companyRemoveFromList',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/organization/v1/{orgId}/masterList/{vendorUploadId}',
    type: 'DELETE'
  },
  {
    cmd: 'getMonitoringStatus',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/company/v1/monitoringStatus',
    type: 'POST'
  },
  {
    cmd: 'postOnboarding',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/user/v1/onboarding',
    type: 'POST'
  },
  {
    cmd: 'postOrgRegister',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/user/v1/register',
    type: 'POST'
  },
  {
    cmd: 'postReactivateSubscription',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/subscription/v1/organization/{orgId}/reactivate',
    type: 'POST'
  },
  {
    cmd: 'postStartSubscription',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/subscription/v1/organization/{orgId}/start',
    type: 'POST'
  },
  {
    cmd: 'postStopSubscription',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/subscription/v1/organization/{orgId}/stop',
    type: 'POST'
  },
  {
    cmd: 'uploadMasterFile',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/organization/v1/{orgId}/upload',
    type: 'POST'
  },
  {
    cmd: 'fileStatus',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/organization/v1/{orgId}/fileStatus',
    type: 'GET'
  },
  {
    cmd: 'viewSummaryResults',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/file/v1/{orgId}/viewSummaryResults',
    type: 'GET'
  },
  {
    cmd: 'viewDetailResults',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/file/v1/{fileUploadId}/viewDetailResults',
    type: 'GET'
  },
  {
    cmd: 'getLikelyMatches',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/organization/v1/{orgId}/likelyMatches',
    type: 'GET'
  },
  {
    cmd: 'convertLmToHc',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/organization/v1/{orgId}/convertLmToHc/{vendorUploadId}',
    type: 'PUT'
  },
  {
    cmd: 'searchCompany',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/company/v1/search',
    type: 'POST'
  },
  {
    cmd: 'updateTandC',
    cmdType: 'secured',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/apiProxy/user/v1/{cuid}/updateTandC',
    type: 'POST'
  },
  {
    cmd: 'getPersonEntitlements',
    cmdType: 'secured',
    contentType: 'application/vnd.com.covisint.platform.person.privilege.v1+json',
    accepts: 'application/vnd.com.covisint.platform.person.privilege.v1+json',
    call: '/p/apiProxy/person/v3/persons/privileges/{personId}',
    type: 'GET'
  },
  {
    cmd: 'getPackageClaims',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.package.claim.v1+json',
    call: '/service/v3/claims',
    type: 'GET'
  },
  {
    cmd: 'getPersonPackageClaims',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.package.grant.claim.v1+json',
    call: '/p/apiProxy/service/v3/persons/{grantee}/packages/{packageId}/claims',
    type: 'GET'
  },
  {
    cmd: 'getCategories',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.category.v1+json',
    call: '/p/apiProxy/service/v3/categories',
    type: 'GET'
  },
  {
    cmd: 'getPersonRequestableApps',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.service.application.v1+json',
    call: '/p/apiProxy/service/v3/applications/persons/{personId}/requestable',
    type: 'GET'
  },
  {
    cmd: 'getPersonRequestableCount',
    accepts: 'text/plain',
    call: '/p/apiProxy/service/v3/applications/persons/{personId}/requestable/count',
    type: 'GET'
  },
  {
    cmd: 'getPersonGrantedApps',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.service.application.v1+json',
    call: '/p/apiProxy/service/v3/applications/persons/{personId}',
    type: 'GET'
  },
  {
    cmd: 'getPersonGrantedAppCount',
    cmdType: 'secured',
    accepts: 'text/plain',
    call: '/p/apiProxy/service/v3/applications/persons/{personId}/count',
    type: 'GET'
  },
  {
    cmd: 'getOrganizationRequestableApps',
    accepts: 'application/vnd.com.covisint.platform.service.application.v1+json',
    call: '/p/apiProxy/service/v3/applications/organizations/{organizationId}',
    type: 'GET'
  },
  {
    cmd: 'getOrganizationRequestableCount',
    accepts: 'text/plain',
    call: '/p/apiProxy/service/v3/applications/organizations/{organizationId}/requestable/count',
    type: 'GET'
  },
  {
    cmd: 'getOrganizationGrantedApps',
    accepts: 'application/vnd.com.covisint.platform.service.application.v1+json',
    call: '/p/apiProxy/service/v3/applications/organizations/{organizationId}',
    type: 'GET'
  },
  {
    cmd: 'getOrganizationGrantedCount',
    accepts: 'text/plain',
    call: '/p/apiProxy/service/v3/applications/organizations/{organizationId}/count',
    type: 'GET'
  },
  {
    cmd: 'getPersonGrantableApps',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.service.application.v1+json',
    call: '/p/apiProxy/service/v3/applications/persons/{personId}/grantable',
    type: 'GET'
  },
  {
    cmd: 'getPersonGrantableCount',
    accepts: 'text/plain',
    call: '/p/apiProxy/service/v3/applications/persons/{personId}/grantable/count',
    type: 'GET'
  },
  {
    cmd: 'getOrganizationGrantableApps',
    accepts: 'application/vnd.com.covisint.platform.service.application.v1+json',
    call: '/p/apiProxy/service/v3/applications/organizations/{organizationId}/grantable',
    type: 'GET'
  },
  {
    cmd: 'getOrganizationGrantableCount',
    accepts: 'text/plain',
    call: '/p/apiProxy/service/v3/applications/organizations/{organizationId}/grantable/count',
    type: 'GET'
  },
  {
    cmd: 'getPersonStatusHistory',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.person.status.history.v1+json',
    call: '/p/apiProxy/person/v3/persons/statusHistory',
    type: 'GET'
  },
  {
    cmd: 'getPersonPasswordChangeHistory',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.authn.password.change.history.req.v1+json',
    call: '/p/apiProxy/authentication/v4/passwords/changeHistory',
    type: 'GET'
  },
  {
    cmd: 'getPersonPendingServicePackages',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.package.request.v1+json',
    call: '/p/apiProxy/service/v3/requests',
    type: 'GET'
  },
  {
    cmd: 'getPackage',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.package.v1+json',
    call: '/p/apiProxy/service/v3/packages/{packageId}',
    type: 'GET'
  },
  {
    cmd: 'denyPackage',
    cmdType: 'secured',
    accepts: 'text/plain',
    type: 'POST',
    call: '/p/apiProxy/service/v3/requests/tasks/deny'
  },
  {
    cmd: 'approvePackage',
    cmdType: 'secured',
    accepts: 'text/plain',
    type: 'POST',
    call: '/p/apiProxy/service/v3/requests/tasks/approve'
  },
  {
    cmd: 'grantClaims',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.package.grant.claim.v1+json',
    call: '/p/apiProxy/service/v3/packages/grants/claims',
    type: 'PUT'
  },
  {
    cmd: 'getOrganizationRegistrationRequest',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.organization.request.v1+json',
    call: '/p/apiProxy/organization/v3/requests',
    type: 'GET'
  },
  {
    cmd: 'getPersonRegistrationRequest',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.person.request.v1+json',
    call: '/p/apiProxy/person/v3/requests',
    type: 'GET'
  },
  {
    cmd: 'approvePersonRegistration',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.person.request.v1+json',
    call: '/p/apiProxy/person/v3/requests/tasks/approve',
    type: 'POST'
  },
  {
    cmd: 'denyPersonRegistration',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.person.request.v1+json',
    call: '/p/apiProxy/person/v3/requests/tasks/deny',
    type: 'POST'
  },
  {
    cmd: 'getAllOrganizationRequests',
    accepts: 'application/vnd.com.covisint.platform.organization.request.v1+json',
    call: '/p/apiProxy/organization/v3/requests',
    type: 'GET'
  },
  {
    cmd: 'getPersonEntitlements',
    cmdType: 'secured',
    contentType: 'application/vnd.com.covisint.platform.person.privilege.v1+json',
    accepts: 'application/vnd.com.covisint.platform.person.privilege.v1+json',
    call: '/p/apiProxy/person/v3/persons/privileges/{personId}',
    type: 'GET'
  },
  { cmd: 'getPersonGrantedCount',
    cmdType: 'secured',
    accepts: 'text/plain',
    call: '/p/apiProxy/person/v3/persons/count',
    type: 'GET'
  },
  {
    cmd: 'suspendOrgPkg',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.package.grant.status.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.grant.status.request.v1+json',
    call: '/p/apiProxy/service/v3/grants/tasks/organization/package/suspend',
    type: 'POST'
  },
  {
    cmd: 'unsuspendOrgPkg',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.package.grant.status.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.grant.status.request.v1+json',
    call: '/p/apiProxy/service/v3/grants/tasks/organization/package/unsuspend',
    type: 'POST'
  },
  {
    cmd: 'initiateNonce',
    cmdType: 'unsecured',
    type: 'GET',
    accepts: 'application/json',
    call: '/p/apiProxy/registration/v1/registrations/open/initiate'
  },
  {
    cmd: 'getOrganizationNonce',
    cmdType: 'nonce',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.organization.v1+json',
    call: '/p/apiProxy/registration/v1/registrations/organizations/{organizationId}'
  },
  {
    cmd: 'getOrganizationsNonce',
    cmdType: 'nonce',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.organization.v1+json',
    call: '/p/apiProxy/registration/v1/registrations/organizations'
  },
  {
    cmd: 'getSecurityQuestionsNonce',
    cmdType: 'nonce',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.securityquestion.v1+json',
    call: '/p/apiProxy/registration/v1/registrations/securityQuestions'
  },
  {
    cmd: 'postUserRegistrationNonce',
    cmdType: 'nonce',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.password.account.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.password.account.v1+json',
    call: '/p/apiProxy/registration/v1/registrations/persons/registration'
  },
  {
    cmd: 'getPasswordPoliciesNonce',
    cmdType: 'nonce',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.password.policy.v1+json',
    call: '/p/apiProxy/registration/v1/registrations/passwords/policies/{policyId}'
  },
  {
    cmd: 'postPersonRequestNonce',
    cmdType: 'nonce',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.request.v1+json',
    call: '/p/apiProxy/registration/v1/registrations/persons/requests'
  },
  {
    cmd: 'getOrgPackageGrantsNonce',
    cmdType: 'nonce',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.grant.v1+json',
    call: '/p/apiProxy/registration/v1/registrations/organizations/{organizationId}/packages'
  },
  {
    cmd: 'validateUsernameEmailNonce',
    cmdType: 'nonce',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.password.account.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.password.account.v1+json',
    call: '/p/apiProxy/registration/v1/registrations/persons/registration/validate'
  },
  {
    cmd: 'securedInitiate',
    cmdType: 'unsecured',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.invitation.v1+json',
    call: '/p/apiProxy/registration/v1/registrations/securedInvite/initiate/{invitationId}'
  },
  {
    cmd: 'getOrgAppsNonce',
    cmdType: 'nonce',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.service.application.v1+json',
    call: '/p/apiProxy/registration/v1/applications/organizations/{organizationId}'
  },
  {
    cmd: 'getOrgAppsCountNonce',
    cmdType: 'nonce',
    type: 'GET',
    accepts: 'text/plain',
    call: '/p/apiProxy/registration/v1/applications/organizations/{organizationId}/count'
  },
  {
    cmd: 'getOrganizationsCountNonce',
    cmdType: 'nonce',
    type: 'GET',
    accepts: 'text/plain',
    call: '/p/apiProxy/registration/v1/registrations/organizations/count'
  },
  {
    cmd: 'getDeviseData',
    accepts: 'application/json',
    contentType: 'application/json',
    call: '/p/amtbProxy/retrieve/v1/deviseData',
    type: 'POST'
  },
  // New Calls-S
  {cmd: 'getOrgRegistrationRequests', call: '/p/apiProxy/registration/v1/organization/requests', type: 'GET', accepts: 'application/vnd.com.covisint.platform.organization.request.v1+json', contentType: 'application/vnd.com.covisint.platform.organization.request.v1+json'},
  {cmd: 'getOrgRegistrationRequestsCount', call: '/p/apiProxy/registration/v1/organization/requests/count', type: 'GET', accepts: 'text/plain'},
  {cmd: 'approveOrgRegistrationRequest', call: '/p/apiProxy/registration/v1/organization/requests/tasks/approve', type: 'POST', accepts: 'application/vnd.com.covisint.platform.organization.request.v1+json'},
  {cmd: 'denyOrgRegistrationRequest', call: '/p/apiProxy/registration/v1/organization/requests/tasks/deny', type: 'POST', accepts: 'application/vnd.com.covisint.platform.organization.request.v1+json'},
  {cmd: 'getPackageByQuery', accepts: 'application/vnd.com.covisint.platform.package.v1+json', call: '/p/apiProxy/service/v3/packages', type: 'GET'},
  {cmd: 'getPersonByQuery', call: '/p/apiProxy/person/v3/persons', type: 'GET', accepts: 'application/vnd.com.covisint.platform.person.v1+json'},
  {cmd: 'getRegistrationRequests', call: '/p/apiProxy/registration/v1/person/requests', type: 'GET', accepts: 'application/vnd.com.covisint.platform.person.request.v1+json', contentType: 'application/vnd.com.covisint.platform.person.request.v1+json'},
  {cmd: 'createRegistrationRequest', 'cmdType': 'unsecured', call: '/p/apiProxy/registration/v1/person/requests', type: 'POST', accepts: 'application/vnd.com.covisint.platform.person.request.v1+json', contentType: 'application/vnd.com.covisint.platform.person.request.v1+json'},
  {cmd: 'getOrganizationSecured', 'cmdType': 'secured', 'call': '/p/apiProxy/organization/v3/organizations/{organizationId}', 'type': 'GET', 'accepts': 'application/vnd.com.covisint.platform.organization.v1+json'},
  {cmd: 'getPasswordPolicySecured', 'cmdType': 'secured', 'call': '/p/apiProxy/authn/v4/passwords/policies/{policyId}', 'type': 'GET', 'accepts': 'application/vnd.com.covisint.platform.password.policy.v1+json'},
  {cmd: 'grantClaims', accepts: 'application/vnd.com.covisint.platform.package.grant.claim.v1+json', contentType: 'application/vnd.com.covisint.platform.package.grant.claim.v1+json', call: '/p/apiProxy/service/v3/packages/grants/claims', type: 'PUT'},
  {cmd: 'initiateRegistration', cmdType: 'unsecured', call: '/p/apiProxy/registration/v1/registrations/open/initiate', type: 'GET', accepts: 'application/vnd.com.covisint.platform.person.invitation.v1+json'},
  {cmd: 'initiateSecuredRegistration', cmdType: 'unsecured', call: '/p/apiProxy/registration/v1/registrations/securedInvite/initiate/{id}', type: 'GET', accepts: 'application/vnd.com.covisint.platform.person.invitation.v1+json'},
  {cmd: 'createRegistrationNonce', cmdType: 'nonce', call: '/p/apiProxy/registration/v1/registrations/persons/registration', type: 'POST', accepts: 'application/vnd.com.covisint.platform.person.password.account.v1+json', contentType: 'application/vnd.com.covisint.platform.person.password.account.v1+json'},
  {cmd: 'createRegistrationRequestNonceWithPkg', cmdType: 'nonce', call: '/p/apiProxy/registration/v1/registrations/persons/requests', type: 'POST', accepts: 'application/vnd.com.covisint.platform.person.request.v1+json', contentType: 'application/vnd.com.covisint.platform.person.request.v1+json'},
  {cmd: 'approvePersonRegistrationRequest', call: '/p/apiProxy/registration/v1/person/requests/tasks/approve', type: 'POST', accepts: 'application/vnd.com.covisint.platform.person.request.v1+json'},
  {cmd: 'denyPersonRegistrationRequest', call: '/p/apiProxy/registration/v1/person/requests/tasks/deny', type: 'POST', accepts: 'application/vnd.com.covisint.platform.person.request.v1+json'},
  {cmd: 'validateRegistrationNonce', cmdType: 'nonce', call: '/p/apiProxy/registration/v1/registrations/persons/registration/validate', type: 'POST', accepts: 'text/plain'},
  // {cmd: 'getOrganizationNonce',cmdType:'nonce',call: '/p/apiProxy/registration/v1/registrations/organizations/{id}', type:'GET', accepts: 'application/vnd.com.covisint.platform.organization.v1+json'},
  {cmd: 'getPasswordPolicyNonce', cmdType: 'nonce', call: '/p/apiProxy/registration/v1/registrations/passwords/policies/{id}', type: 'GET', accepts: 'application/vnd.com.covisint.platform.password.policy.v1+json'},
  {cmd: 'getAttributeTemplatesNonce', cmdType: 'nonce', call: '/p/apiProxy/registration/v1/registrations/attributeTemplates', type: 'GET', accepts: 'application/vnd.com.covisint.platform.attribute.template.v1+json'},
  {cmd: 'getOrganizationPackagesSecured', 'cmdType': 'secured', 'call': '/p/apiProxy/service/v3/organizations/{organizationId}/packages', 'type': 'GET', 'accepts': 'application/vnd.com.covisint.platform.package.grant.v1+json'},
  {cmd: 'validatePasswordSecured', call: '/p/apiProxy/person/v3/persons/password/validate', type: 'POST', accepts: 'application/vnd.com.covisint.platform.password.validation.response.v1+json', 'contentType': 'application/vnd.com.covisint.platform.password.validation.v1+json'},
  {cmd: 'getPackageRequestsCount', call: '/p/apiProxy/service/v3/requests/count', type: 'GET', accepts: 'text/plain'},
  {cmd: 'getOrganizationPackagesCount', call: '/p/apiProxy/service/v3/organizations/{organizationId}/packages/count', type: 'GET', accepts: 'text/plain'},
  {cmd: 'getRegistrationRequestsCount', call: '/p/apiProxy/registration/v1/person/requests/count', type: 'GET', accepts: 'text/plain'},
  {cmd: 'getPackagesRequestedCount', call: '/p/apiProxy/service/v3/persons/{personId}/packages/count', type: 'GET', accepts: 'text/plain'},
  {cmd: 'validatePasswordNonce', cmdType: 'nonce', call: '/p/apiProxy/registration/v1/registrations/persons/password/validate', type: 'POST', accepts: 'application/vnd.com.covisint.platform.password.validation.response.v1+json', contentType: 'application/vnd.com.covisint.platform.password.validation.v1+json'},
  // Social Login Calls
  {cmd: 'getSocialLoginAccounts', call: '/p/apiProxy/social-accounts/v1/social/accounts/{personId}', type: 'GET', accepts: 'application/json', contenttype: 'application/json'},
  {cmd: 'unlinkSocialLoginAccount', call: '/p/apiProxy/social-accounts/v1/social/unlink/{personId}/{configId}', type: 'DELETE', accepts: 'application/json', contenttype: 'application/json'},
  {cmd: 'getlinkableSocialAccounts', call: '/p/apiProxy/social-accounts/v1/social', type: 'GET', accepts: 'application/json', contentType: 'application/json'},
  // twitter...
  {cmd: 'twitterAuthentication', call: '/p/apiProxy/social-accounts/v1/social/twitter/authorize', type: 'GET', accepts: 'application/json', contentType: 'application/json'},
  {cmd: 'twitterLoginCallback', call: '/p/apiProxy/social-accounts/v1/social/callback/twitter', type: 'GET', accepts: 'application/json', contentType: 'application/json'},
  {cmd: 'twitterLinkCallback', call: '/p/apiProxy/social-accounts/v1/social/link/twitter', type: 'GET', accepts: 'application/json', contentType: 'application/json'},

  // facebook...
  {cmd: 'facebookAuthentication', call: '/p/apiProxy/social-accounts/v1/social/fb/authorize', type: 'GET', accepts: 'application/json', contenttype: 'application/json'},
  {cmd: 'facebookLoginCallback', call: '/p/apiProxy/social-accounts/v1/social/callback/fb', type: 'GET', accepts: 'application/json', contentType: 'application/json'},
  {cmd: 'facebookLinkCallback', call: '/p/apiProxy/social-accounts/v1/social/link/facebook/{personId}', type: 'GET', accepts: 'application/json', contentType: 'application/json'}
]

export {
  errorHandler,
  defs
}



// WEBPACK FOOTER //
// ./src/plugins/CustomAPI.js